<app-breadcrumb [home]="home" [items]="breadcrumbs()" />

@if (carregando()) {
  <div class="detail__state">
    <app-cog-loading-spinner />
  </div>
} @else if (erro()) {
  <div class="detail__state detail__state--error" role="alert">
    <i class="pi pi-lock" aria-hidden="true"></i>
    <strong>{{ erro() }}</strong>
    <span class="detail__state-hint">
      A call interna (e a entrevista) é privada: só quem participou a vê, mesmo com empresa ou deal
      vinculado. Se você não participou, peça a um participante para compartilhar com você ou
      liberar para o time.
    </span>
    <app-button
      [label]="'Tentar de novo'"
      [theme]="'outline-grey'"
      [size]="'small'"
      [type]="'button'"
      (sendButtonClick)="carregar()" />
  </div>
} @else if (meeting(); as m) {
  <app-meeting-detail-header
    [meeting]="m"
    [podeAgir]="podeAgir()"
    [ocupada]="ocupada()"
    [baixando]="baixando()"
    [canArchive]="canArchive()"
    [canDelete]="canDelete()"
    (lifecycleAction)="executeLifecycleAction($event)"
    (meetingUpdated)="aoVincular($event)"
    (openVisibility)="openVisibility()"
    (baixar)="baixar()"
    (alternarAcesso)="alternarAcesso()"
    (compartilhar)="compartilhar()"
    (vincular)="vincular()"
    (abrirArtefato)="abrirArtefato($event)" />

  <div class="detail">
    <div class="detail__main">
      <app-meeting-player
        [meeting]="m"
        [videoUrl]="videoUrl()"
        [videoErro]="videoErro()"
        (tempo)="tempoAtual.set($event)"
        (falhou)="videoFalhou($event)"
        (carregarDeNovo)="carregarVideo()"
        (verLinhaDoTempo)="abrirLinhaDoTempo()" />

      @if (m.hasRecording) {
        <app-meeting-chapters
          [capitulos]="insights()?.chapters ?? null"
          [processando]="insights()?.status === 'Processing'"
          [semCapitulos]="
            insights()?.summaryStatus === 'Ready' || insights()?.summaryStatus === 'Failed'
          "
          [temVideo]="!!videoUrl()"
          (irPara)="irPara($event)" />
      }
    </div>

    <section class="detail__panel" aria-label="Transcrição, resumo, vínculos e detalhes">
      <app-tab-view
        [tabViewItems]="itensDasAbas"
        [tabIndex]="abaAtual()"
        [showCounts]="false"
        (sendTabViewActiveIndex)="abaAtual.set($event)" />

      <div class="detail__panel-body">
        @switch (aba()) {
          @case ('transcricao') {
            @if (!m.hasTranscript) {
              <div class="detail__empty">
                <i class="pi pi-file" aria-hidden="true"></i>
                @if (transcricaoACaminho()) {
                  <strong>A transcrição está a caminho</strong>
                  <span>Ela é feita depois do vídeo e aparece aqui sozinha.</span>
                } @else if (semTranscricaoAEsperar()) {
                  <strong>Ainda não há transcrição</strong>
                  <span>Ela aparece aqui depois que a reunião for gravada.</span>
                } @else {
                  <strong>Sem transcrição</strong>
                  <span>A reunião não foi gravada.</span>
                }
              </div>
            } @else if (transcricaoErro()) {
              <div class="detail__empty" role="alert">
                <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
                <strong>{{ transcricaoErro() }}</strong>
              </div>
            } @else if (carregandoTranscricao()) {
              <div class="detail__empty">
                <app-cog-loading-spinner />
              </div>
            } @else if (!falas().length) {
              <div class="detail__empty">
                <i class="pi pi-file" aria-hidden="true"></i>
                <strong>A transcrição desta reunião veio vazia.</strong>
              </div>
            } @else {
              <app-meeting-transcript-panel
                [falas]="falas()"
                [tempoAtual]="tempoAtual()"
                [temVideo]="!!videoUrl()"
                (irPara)="irPara($event)" />
            }
          }
          @case ('resumo') {
            <app-meeting-summary-panel
              [insights]="insights()"
              [temTranscricao]="m.hasTranscript"
              [transcricaoACaminho]="transcricaoACaminho()"
              [carregando]="carregandoInsights()"
              [erro]="insightsErro()"
              [podeGerar]="podeAgir()"
              [gerando]="gerandoInsights()"
              [temVideo]="!!videoUrl()"
              [podeVerSessoes]="podeAgir()"
              (verSessoes)="verSessoes()"
              (gerar)="gerarInsights()"
              (irPara)="irPara($event)" />
          }
          @case ('vinculos') {
            <app-meeting-links-panel
              [meeting]="m"
              [insights]="insights()"
              [interno]="podeAgir()"
              [ocupada]="ocupada()"
              [temVideo]="!!videoUrl()"
              [decidindo]="decidindo()"
              (confirmarSugestao)="aplicarSugestao($event)"
              (descartarSugestao)="dispensarSugestao($event)"
              (vincular)="vincular()"
              (desvincularDeal)="desvincularDeal($event)"
              (desvincularVinculo)="desvincularVinculo($event)"
              (irPara)="irPara($event)" />
          }
          @case ('detalhes') {
            <app-meeting-detail-side [meeting]="m" [interno]="podeAgir()" />
          }
        }
      </div>
    </section>
  </div>

  @if (podeAgir()) {
    <app-modal-link-meeting #modalVincular (vinculou)="aoVincular($event)" />
    <app-modal-share-meeting #modalCompartilhar (acessoGeralMudou)="aoVincular($event)" />
    <!-- Card 3803: chaves de visibilidade, Privar e o painel de regras. -->
    <app-modal-meeting-visibility
      #modalVisibility
      (changed)="aoVincular($event)"
      (openRules)="rulesOpen.set(true)" />
    <app-meeting-visibility-rules-drawer [(visible)]="rulesOpen" />
    <app-modal-meeting-agent-runs
      #modalSessoes
      [runs]="insights()?.agentRuns ?? null"
      [podeGerar]="!!insights()?.canReprocess"
      [gerando]="gerandoInsights()"
      [podeAbrirSessao]="ehAdmin()"
      (gerar)="gerarInsights()" />
  }
}
